import React, { useState, useEffect } from 'react';
import { vacancyService, companyService, placementDriveService } from '../../services/api';
import { getUserData } from '../../utils/auth';
import './CoordinatorVacancies.css';

function CoordinatorVacancies() {
  const userData = getUserData();
  const collegeId = userData?.collegeId || userData?.CollegeId;
  const cordinatorId = userData?.cordinatorId || userData?.CordinatorId;

  const [vacancies, setVacancies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [drives, setDrives] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    Title: '',
    Description: '',
    Conditions: '',
    Question1: '',
    Question2: '',
    Question3: '',
    LastDate: '',
    CompanyId: '',
    CordinatorId: cordinatorId || '',
    PlacementDriveId: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (collegeId) {
      loadData();
      loadDropdowns();
    }
  }, [collegeId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await vacancyService.getVacanciesByCollege(collegeId);
      setVacancies(data || []);
    } catch (error) {
      alert('Error loading vacancies: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadDropdowns = async () => {
    try {
      const [companiesData, drivesData] = await Promise.all([
        companyService.getCompanies(),
        placementDriveService.GetPlacementDrivesByCollege(collegeId)
      ]);
      setCompanies(companiesData || []);
      setDrives(drivesData || []);
    } catch (error) {
      console.error('Error loading dropdowns:', error);
    }
  };

  const handleAdd = () => {
    setEditing(null);
    setFormData({
      Title: '', Description: '', Conditions: '', Question1: '', Question2: '', Question3: '',
      LastDate: '', CompanyId: '', CordinatorId: cordinatorId || '', PlacementDriveId: ''
    });
    setIsModalOpen(true);
  };

  const handleEdit = (v) => {
    setEditing(v);
    setFormData({
      Id: v.Id,
      Title: v.Title || '', Description: v.Description || '', Conditions: v.Conditions || '',
      Question1: v.Question1 || '', Question2: v.Question2 || '', Question3: v.Question3 || '',
      LastDate: v.LastDate ? v.LastDate.split('T')[0] : '',
      CompanyId: v.CompanyId || '', CordinatorId: cordinatorId || '', PlacementDriveId: v.PlacementDriveId || ''
    });
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = { ...formData, CordinatorId: cordinatorId || null };
      await vacancyService.saveVacancy(payload);
      setIsModalOpen(false);
      loadData();
    } catch (error) {
      alert('Error saving: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!collegeId) return <div className="coord-vacancies"><p>College session not found.</p></div>;

  return (
    <div className="coord-vacancies">
      <div className="page-header">
        <h1>Vacancies (College)</h1>
        <p>Manage vacancies for placement drives in your college</p>
        <button className="btn-add" onClick={handleAdd}>+ Add Vacancy</button>
      </div>

      {loading && !vacancies.length ? <p>Loading...</p> : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr><th>Title</th><th>Company</th><th>Placement Drive</th><th>Last Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {vacancies.map((v) => (
                <tr key={v.Id}>
                  <td>{v.Title}</td>
                  <td>{v.Company?.Name}</td>
                  <td>{v.PlacementDrive?.Title}</td>
                  <td>{v.LastDate ? new Date(v.LastDate).toLocaleDateString() : ''}</td>
                  <td><button className="btn-edit" onClick={() => handleEdit(v)}>Edit</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          {vacancies.length === 0 && <p className="no-data">No vacancies yet.</p>}
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editing ? 'Edit' : 'Add'} Vacancy</h2>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group"><label>Title *</label><input type="text" value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })} required /></div>
              <div className="form-group"><label>Description</label><textarea value={formData.Description} onChange={(e) => setFormData({ ...formData, Description: e.target.value })} rows={3} /></div>
              <div className="form-group"><label>Conditions</label><textarea value={formData.Conditions} onChange={(e) => setFormData({ ...formData, Conditions: e.target.value })} rows={2} /></div>
              <div className="form-group"><label>Last Date</label><input type="date" value={formData.LastDate} onChange={(e) => setFormData({ ...formData, LastDate: e.target.value })} /></div>
              <div className="form-group"><label>Company</label>
                <select value={formData.CompanyId} onChange={(e) => setFormData({ ...formData, CompanyId: e.target.value })} required>
                  <option value="">Select Company</option>
                  {companies.map((c) => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Placement Drive *</label>
                <select value={formData.PlacementDriveId} onChange={(e) => setFormData({ ...formData, PlacementDriveId: e.target.value })} required>
                  <option value="">Select Drive</option>
                  {drives.map((d) => <option key={d.Id} value={d.Id}>{d.Title}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Question 1</label><input type="text" value={formData.Question1} onChange={(e) => setFormData({ ...formData, Question1: e.target.value })} /></div>
              <div className="form-group"><label>Question 2</label><input type="text" value={formData.Question2} onChange={(e) => setFormData({ ...formData, Question2: e.target.value })} /></div>
              <div className="form-group"><label>Question 3</label><input type="text" value={formData.Question3} onChange={(e) => setFormData({ ...formData, Question3: e.target.value })} /></div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="btn-save" disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CoordinatorVacancies;
